/**
 * Explain: 项目中接口地址配置
 * */
const result = {
	// start====================登录====================
	// end====================登录====================

	// 获取高德天气
	GET_WEATHER_INFO: `https://restapi.amap.com/v3/weather/weatherInfo`
}
export default result
